import axios from '../../../services/axios';
import { AxiosResponse } from 'axios';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

type GetConnectedUserAccountsParams = {
  partnerId: string;
  orgId: string;
};

export const getConnectedUserAccounts = async ({
  partnerId,
  orgId,
}: GetConnectedUserAccountsParams): Promise<AxiosResponse> => {
  try {
    const response = await axios.get(
      `${VITE_APP_API_URL}/auth-service/connected_accounts?partner=${partnerId}&org_id=${orgId}`,
    );
    return response?.data;
  } catch (err: any) {
    console.error('err', err);
    return Promise.resolve<any>([]);
  }
};
